import React, { useEffect, useRef } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import PhoneImage from '@assets/courier-promotion1-phone.png';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import AnimatedGIF from '@assets/courier-promotion-animated-screen.gif';
import { useTranslation } from 'react-i18next';
import { useScroll } from '@src/shared/hooks/use-scroll';
import { moveSmartPhoneImageAccordingtoScroll$Animation } from '../../shared/animations';
import useInViewport from '@src/shared/hooks/use-in-viewport';
const CourierPromotionContent = () => {
  const classes = useStyles();
  const {isResolutionMobile} = useDeviceDetect()
  const { t } = useTranslation()
  const headerIconSize = isResolutionMobile ? 24 : 33
  const { scrollTop, scrolledPercentage } = useScroll()
  const phoneImageContentRef = useRef(null)
  const phoneImageContentIsInViewport = useInViewport(phoneImageContentRef)

  useEffect(()=> {
    moveSmartPhoneImageAccordingtoScroll$Animation(phoneImageContentRef.current, scrolledPercentage, phoneImageContentIsInViewport)
  },[scrollTop])
  return (
    <div className={classes.courierPromotionContent}>
      <div className="courierpromotion-side-section-1">
        <div className='title-holder'>
            <JetFontIcon
                className="title-icon"
                iconname={JET_FONTICON_ALIASES.HAND_HEART}
                customstyle={{marginTop:`-${(headerIconSize / 2)}px`, height:`${headerIconSize}px`}}
                size={headerIconSize}
              />{' '}
            <Typography
              variant={`${isResolutionMobile ? 'h3' : 'h1'}`} 
              className={`${isResolutionMobile ? 'heading_l' : 'heading_xxl'} courierpromotion-title`} 
              align={"left"}
            >
              
              {t('new_productoverview_courier.section6_title')}
            </Typography>
          </div>
        {isResolutionMobile &&<div className='image-holder'>
            <img src={AnimatedGIF} loading='lazy' className='courier-promotion-animation' />
            <img src={PhoneImage} className='phone-image-mobile-view' /> 
          </div>}
        <Typography
          className="body_regular courierpromotion-description"
          variant="body1"
          align="left"
        >
        {t('new_productoverview_courier.section6_description')}
          <ul className="articles">
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                 {t('new_productoverview_courier.section6_article1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
               {t('new_productoverview_courier.section6_article2')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                {t('new_productoverview_courier.section6_article3')}
              </Typography>
            </li>
          </ul>
        </Typography>
      </div>
     {!isResolutionMobile && <div className="courierpromotion-side-section-2">
        <div ref={phoneImageContentRef}>        
          <img src={AnimatedGIF} loading='lazy' className='courier-promotion-animation' />
          <img src={PhoneImage} className='courier-promotion-animation-bg' />
        </div>
      </div>}
    </div>
  );
};

export default CourierPromotionContent;
